import { graphql } from '@api/generated';
import { getClient } from '../../../api/client';

const updateCallTimeoutWarningSettingMutation = graphql(`
  mutation updateCallTimeoutWarningSettingMutation(
    $contactCenterSettings: ContactCenterSettingsInput!
  ) {
    updateContactCenterSettings(contactCenterSettings: $contactCenterSettings) {
      callTimeoutWarning {
        isEnabled
      }
    }
  }
`);

async function updateCallTimeoutWarningSetting(
  isEnabled: boolean,
): Promise<boolean> {
  const result = await getClient().mutate({
    mutation: updateCallTimeoutWarningSettingMutation,
    variables: {
      contactCenterSettings: {
        callTimeoutWarning: {
          isEnabled,
        },
      },
    },
  });

  if (result.errors?.length) {
    throw new Error(result.errors[0].message);
  }

  return (
    result.data?.updateContactCenterSettings?.callTimeoutWarning?.isEnabled ??
    isEnabled
  );
}

export default updateCallTimeoutWarningSetting;
